// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3o-VH","title":"styles_title__37jYz"};